<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>活动主题管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-if="!isAddUser"
         class="main">
      <div class="head">
        <h4>活动主题管理</h4>
        <p :style="{'color': isSimple ? '#E27B02' : '#194897'}" @click="changeUserForm">+新增主题</p>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <activitythemetable :tableData="userTableList"
                              @changeClick="reviseClick"
                              @closeClick="closeClick"></activitythemetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>

      </div>
    </div>

    <div v-if="isAddUser"
         class="main">
      <div class="head">
        <h4>新增主题</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 300px);margin:0 auto;padding:20px;">
          <activitythemeform :ruleForm="ruleForm"
                             @updataForm="updataForm"
                             @closeForm="closeForm"
                             @submitForm="submitForm"></activitythemeform>

          <!-- <el-button @click="dialogFormVisible = true">弹框表单</el-button> -->
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { activitythemetable, activitythemeform } from "@/components/index";
import { listTheme, updateTheme, addTheme, getTheme, deleteTheme } from "@/api/pictureActivityTheme";
import { getDate, formatConversion } from "@/plugins/getdate";

export default {
  components: {
    activitythemetable: activitythemetable,
    activitythemeform: activitythemeform
  },

  data () {
    return {
      roleName: [],
      myroleIds: [],

      ruleForm: {
        title: "",
        theme: "",
        status: '0',
        desc: "",
        thumb: null
      },


      total: 0,
      currentPage: 1,
      pageSize: 10,
      isAddUser: false,
      userTableList: [],
      mydialogVisible: false,
      myform: {
        id: "",
        name: "",
        mobile: "",
        email: "",
        newpsw: "",
        // password: "123456",
        sort: 0,
        status: '0',
        userType: 0,
        roleIds: ''
        // updateAt:''
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机", trigger: "blur" },
          { min: 11, max: 11, message: "长度在 11 个字符", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { min: 2, max: 60, message: "长度不超过 60 个字符", trigger: "blur" }
        ],
        newpsw: [
          { min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur" }
        ],
        roleIds: [
          { type: 'array', required: true, message: '请至少选择一个用户角色', trigger: 'change' }
        ],
      },
      timeInt: '',
      isRefresh: false
    };
  },
  methods: {



    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize }
      // console.log(data)
      this.listThemeAsync(data)
    },





    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },




    changeUserForm () {
      this.isAddUser = !this.isAddUser;
      this.ruleForm = {
        title: "",
        theme: "",
        status: "0",
        desc: "",
        thumb: null
      }
    },
    //roleform关闭窗口事件
    closeForm () {
      this.changeUserForm();

    },

    //roleform提交表单事件
    submitForm (data) {
      this.addThemeAsync(data);
    },

    updataForm (val) {
      this.updateThemeAsync(val)
      this.isAddUser = !this.isAddUser
    },
    dialogSubmit (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.myform.newpsw) {
            this.myform.password = this.$md5(this.myform.newpsw)
          }
          this.myform.roleIds = ''
          for (let i = 0; i < this.myroleIds.length; i++) {
            if (i === this.myroleIds.length - 1) {
              this.myform.roleIds += this.myroleIds[i]
            } else {
              this.myform.roleIds += this.myroleIds[i] + ','
            }
          }
          this.updateUserAsync(this.myform);
        } else {
          return false;
        }
      });
    },
    //修改用户
    reviseClick (scope) {
      this.getThemeAsync(scope.row.id)
    },

    //停用或开启用户
    closeClick (val) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let closeMsg = val.row;
          if (closeMsg.status === 0) {
            closeMsg.status = 1;
          } else {
            closeMsg.status = 0;
          }
          this.updateThemeAsync(closeMsg);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },




    //获取活动主题
    async listThemeAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listTheme(val);
      if (status) {
        this.total = pagination.total
        this.userTableList = data
        for (let i = 0; i < this.userTableList.length; i++) {
          // console.log(this.userTableList[i].createAt.toString())
          this.userTableList[i].createAtMY = formatConversion(this.userTableList[i].createAt.toString()).substring(0, 10);
        }

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },


    //查询活动主题
    async getThemeAsync (val, flag) {
      let { status, data, message, errors } = await getTheme(val);
      if (status) {
        this.ruleForm = data
        this.ruleForm.status = String(this.ruleForm.status)
        this.isAddUser = !this.isAddUser
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除活动主题
    async deleteThemeAsync (val) {
      let { status, data, message, errors } = await deleteTheme(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改活动主题信息
    async updateThemeAsync (val) {
      let { status, data, message, errors } = await updateTheme(val);
      if (status) {
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加活动主题
    async addThemeAsync (val) {
      let { status, data, message, errors } = await addTheme(val);
      if (status) {
        this.$message.success("添加成功！");
        this.isAddUser = !this.isAddUser
        this.handleCurrentChange(1);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });


      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./activitythememanage.scss";

h4 {
  font-size: 18px;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}
</style>
